import React, { useEffect, useState } from "react";
import { Headset } from "lucide-react";
import { COLORS } from "../constants";
import { pill, fontSerif } from "./styles";

/**
 * VRButton — appears at the top of the HUD only when the device reports
 * `navigator.xr.isSessionSupported('immersive-vr')` is true.
 */
export default function VRButton({ xrStore }) {
  const [supported, setSupported] = useState(false);
  const [inSession, setInSession] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (typeof navigator === "undefined" || !navigator.xr) {
      setSupported(false);
      return;
    }
    navigator.xr
      .isSessionSupported("immersive-vr")
      .then((ok) => {
        if (!cancelled) setSupported(!!ok);
      })
      .catch(() => {
        if (!cancelled) setSupported(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Track session start/end on the xrStore
  useEffect(() => {
    if (!xrStore || typeof xrStore.subscribe !== "function") return;
    const unsub = xrStore.subscribe((s) => setInSession(!!s.session));
    return unsub;
  }, [xrStore]);

  if (!supported) return null;

  const onClick = () => {
    if (!xrStore) return;
    if (inSession && typeof xrStore.exitXR === "function") {
      xrStore.exitXR();
    } else if (typeof xrStore.enterVR === "function") {
      xrStore.enterVR();
    }
  };

  return (
    <button
      data-testid="zone-vr-button"
      onClick={onClick}
      style={{
        ...pill,
        padding: "8px 14px",
        color: COLORS.ivory,
        fontFamily: fontSerif,
        fontSize: 12,
        letterSpacing: 2,
        textTransform: "uppercase",
        fontWeight: 600,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 8,
        border: `1px solid ${inSession ? COLORS.gold : COLORS.navyMid}`,
      }}
    >
      <Headset size={14} color={COLORS.gold} />
      {inSession ? "Exit VR" : "Enter VR"}
    </button>
  );
}
